import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { VehicleModel }               from '../vehicles/models/vehicle';
import { VehicleRegistrationService } from './vehicle-registration.service';

@Component({
  selector   : 'wor-vehicle-registration-status',
  template: require('./vehicle-registration.status.component.html')
})
export class VehicleRegistrationStatusComponent {
  @Input() vehicle: VehicleModel;

  constructor (
    private registrationService: VehicleRegistrationService,
    private translateService   : TranslateService
  ) {}

  get classes () : Array<string> {
    return [
        this.registrationService.hasRegistrationId(this.vehicle)
          ? 'bg-success'
          : 'bg-danger'
      ];
  }

  get message () : string {
    return this.registrationService.hasRegistrationId(this.vehicle)
      ? this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.VERIFIED')
      : this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.NOT_VERIFIED');
  }
}
